/* Magno Botanics – rediseño A: títulos de tarjetas, etiquetas de descuento y barra fija de compra */
(function () {
  'use strict';

  var SEP = /\s+[·\-–—|]\s+/;

  function splitTitles(root) {
    (root || document).querySelectorAll('.card__heading a:not([data-mb])').forEach(function (a) {
      a.setAttribute('data-mb', '1');
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t) return;
      var parts = t.split(SEP);
      var name = parts.shift();
      a.textContent = '';
      var n = document.createElement('span');
      n.className = 'mb-name';
      n.textContent = name;
      a.appendChild(n);
      if (parts.length) {
        var s = document.createElement('span');
        s.className = 'mb-sub';
        s.textContent = parts.join(' · ');
        a.appendChild(s);
      }
    });
    (root || document).querySelectorAll('.card__badge .badge:not([data-mb])').forEach(function (b) {
      b.setAttribute('data-mb', '1');
      var m = (b.textContent || '').match(/(\d+)\s*%\s*OFF/i);
      if (m) b.textContent = '-' + m[1] + '%';
    });
  }

  var pending = null;
  function schedule(node) {
    if (pending) return;
    pending = setTimeout(function () { pending = null; splitTitles(document); }, 60);
  }

  function initSticky() {
    var bar = document.getElementById('mb-sticky');
    if (!bar) return;
    var main = document.querySelector('.product__info-container .product-form__submit') || document.querySelector('.product-form__submit');
    if (!main) { bar.parentNode.removeChild(bar); return; }
    var btn = bar.querySelector('.mb-sticky__btn');
    function syncState() {
      btn.disabled = !!main.disabled;
      var label = main.querySelector('span');
      if (main.disabled && label) btn.textContent = label.textContent.trim();
    }
    syncState();
    new MutationObserver(syncState).observe(main, { attributes: true, attributeFilter: ['disabled'] });
    btn.addEventListener('click', function () {
      if (!main.disabled) main.click();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('mb-has-sticky', show);
      }).observe(main);
    }
  }

  function splitProductTitle() {
    var h = document.querySelector('.product__title h1:not([data-mb])');
    if (!h) return;
    h.setAttribute('data-mb', '1');
    var t = (h.textContent || '').replace(/\s+/g, ' ').trim();
    var parts = t.split(SEP);
    if (parts.length < 2) return;
    var name = parts.shift();
    h.textContent = '';
    var n = document.createElement('span');
    n.className = 'mb-ptitle__name';
    n.textContent = name;
    var s = document.createElement('span');
    s.className = 'mb-ptitle__sub';
    s.textContent = parts.join(' · ');
    h.appendChild(n);
    h.appendChild(s);
  }

  function init() {
    splitProductTitle();
    splitTitles(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
